<template>
  <VWidget
    :title="$t('Order Summary')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-btn
        :disabled="!order.documents || order.documents.length === 0"
        :loading="loadingDocument"
        small
        color="primary"
        @click="printInvoice()"
      >
        {{ $t('Invoice') }}
      </v-btn>
      <v-btn
        v-if="order.shipping && order.shipping.method"
        :disabled="cannot('fulfill')"
        class="primary"
        small
        @click="$emit('fulfill')"
      >
        {{ $t('Ship Items') }}
      </v-btn>
    </div>
    <div slot="widget-content">
      <order-single-summary-items :order="order" />

      <v-divider class="my-3"/>

      <order-single-summary-subtotals :order="order" />

      <v-divider class="my-3"/>

      <order-single-summary-shipping :order="order" />

      <v-divider class="my-3"/>

      <order-single-summary-discounts :order="order" />

      <v-divider class="my-3"/>

      <v-list
        dense
        two-line
      >
        <v-list-group append-icon>
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title class="title">{{ $t('Taxes') }}</v-list-tile-title>
            </v-list-tile-content>

            <v-icon v-if="order.taxes && order.taxes.length > 0">keyboard_arrow_down</v-icon>

            <v-list-tile-action>
              <v-chip
                small
                color="primary"
                dark
              >
                {{ order.summary.total_taxes | money }}
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>

          <template v-if="order.taxes && order.taxes.length > 0">
            <v-list-tile
              v-for="(tax, index) in order.taxes"
              :key="`tax-${index}`"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title>{{ tax.name }}</v-list-tile-sub-title>
                <v-list-tile-title>
                  {{ $t('Rate:') }} {{ tax.rate }}
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-chip
                  small
                  color="transparent"
                >
                  {{ tax.tax | money }}
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>
      </v-list>

      <v-divider class="my-3"/>

      <v-list
        v-if="order.summary.total_refunded.amount > 0"
        dense
        two-line
      >
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="title">{{ $t('Refunded') }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-chip
              small
              color="primary"
              dark
            >
              {{ order.summary.total_refunded | money }}
            </v-chip>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-divider
        v-if="order.summary.total_refunded.amount !== '0'"
        class="my-3"/>

      <v-toolbar
        color="primary"
        dark>
        <v-toolbar-title>{{ $t('Total') }}</v-toolbar-title>

        <v-spacer/>

        {{ order.summary.total_due | money }}
      </v-toolbar>
    </div>
  </VWidget>
</template>

<script>
import { mapGetters } from 'vuex'
import OrderSingleSummaryDiscounts from './OrderSingleSummaryDiscounts'
import OrderSingleSummaryShipping from './OrderSingleSummaryShipping'
import OrderSingleSummaryItems from './OrderSingleSummaryItems'
import OrderSingleSummarySubtotals from './OrderSingleSummarySubtotals'

export default {
  name: 'OrderSingleSummary',
  components: {
    OrderSingleSummarySubtotals,
    OrderSingleSummaryItems,
    OrderSingleSummaryShipping,
    OrderSingleSummaryDiscounts
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loadingDocument: false
    }
  },

  computed: {
    ...mapGetters(['orderStateMachine'])
  },

  methods: {
    cannot (action) {
      return this.orderStateMachine && this.order && this.orderStateMachine.cannot(action, this.order.status)
    },

    printInvoice () {
      const doc = this.order.documents.find(doc => doc.type === 'invoice')
      if (!doc) {
        this.$toast.warning(this.$t('There is no invoice associated with this order.'))
        return
      }

      this.loadingDocument = true
      this.order.printDocument(doc).catch(e => {
        this.$toast.error(this.$t(e.message))
      }).finally(() => {
        this.loadingDocument = false
      })
    }
  }
}
</script>
